import axios from 'axios'
import store from '@/store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '/api/qzctech/photo',
  timeout: 20000,
})
http.interceptors.request.use((config) => {
  if (store.state.token) config.headers.Authorization = `Bearer ${store.state.token}`
  return config
})
http.interceptors.response.use(
  (response) => {
    const value = response.data
    if (value && value.code !== 200) return Promise.reject(new Error(value.message || '操作失败'))
    return value
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit('clearAuth')
      const base = (process.env.BASE_URL || '/').replace(/\/$/, '')
      const loginPath = `${base}/login`
      if (!window.location.pathname.endsWith('/login')) {
        window.location.href = loginPath
      }
    }
    return Promise.reject(error)
  }
)

export default {
  login: (data) => http.post('/auth/login', data),
  me: () => http.get('/auth/me'),
  dashboard: () => http.get('/admin/dashboard'),
  categories: () => http.get('/admin/category/list'),
  saveCategory: (data) => http.post('/admin/category/save', data),
  statusCategory: (data) => http.post('/admin/category/status', data),
  deleteCategory: (id) => http.post(`/admin/category/delete/${id}`),
  tools: () => http.get('/admin/tool/list'),
  saveTool: (data) => http.post('/admin/tool/save', data),
  statusTool: (data) => http.post('/admin/tool/status', data),
  deleteTool: (id) => http.post(`/admin/tool/delete/${id}`),
  quoteAiModel: (data) => http.post('/admin/ai-model/quote', data),
  aiModels: () => http.get('/admin/ai-model/list'),
  saveAiModel: (data) => http.post('/admin/ai-model/save', data),
  statusAiModel: (data) => http.post('/admin/ai-model/status', data),
  activateAiModel: (id) => http.post(`/admin/ai-model/activate/${id}`),
  deleteAiModel: (id) => http.post(`/admin/ai-model/delete/${id}`),
  prompts: () => http.get('/admin/prompt/list'),
  savePrompt: (data) => http.post('/admin/prompt/save', data),
  statusPrompt: (data) => http.post('/admin/prompt/status', data),
  deletePrompt: (id) => http.post(`/admin/prompt/delete/${id}`),
  templates: (params) => http.get('/admin/template/list', { params }),
  templateDetail: (id) => http.get(`/admin/template/${id}`),
  saveTemplate: (data) => http.post('/admin/template/save', data),
  statusTemplate: (data) => http.post('/admin/template/status', data),
  deleteTemplate: (id) => http.post(`/admin/template/delete/${id}`),
  banners: () => http.get('/admin/banner/list'),
  saveBanner: (data) => http.post('/admin/banner/save', data),
  statusBanner: (data) => http.post('/admin/banner/status', data),
  deleteBanner: (id) => http.post(`/admin/banner/delete/${id}`),
  customers: (params) => http.get('/admin/customer/list', { params }),
  customerDetail: (id) => http.get('/admin/customer/detail', { params: { id } }),
  statusCustomer: (data) => http.post('/admin/customer/status', data),
  giftPoints: (data) => http.post('/admin/customer/gift-points', data),
  tasks: (params) => http.get('/admin/task/list', { params }),
  works: (params) => http.get('/admin/work/list', { params }),
  deleteWork: (id) => http.post(`/admin/work/delete/${id}`),
  products: () => http.get('/admin/product/list'),
  saveProduct: (data) => http.post('/admin/product/save', data),
  statusProduct: (data) => http.post('/admin/product/status', data),
  deleteProduct: (id) => http.post(`/admin/product/delete/${id}`),
  orders: (params) => http.get('/admin/order/list', { params }),
  rechargeGift: () => http.get('/admin/recharge-gift'),
  saveRechargeGift: (data) => http.post('/admin/recharge-gift/save', data),
  mediaList: (params) => http.get('/admin/media/list', { params }),
  upload: (file) => {
    const data = new FormData()
    data.append('file', file)
    return http.post('/admin/media/upload', data, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
}
